import { render, staticRenderFns } from "./bom_init.vue?vue&type=template&id=46f223ed&scoped=true&"
import script from "./bom_init.vue?vue&type=script&lang=js&"
export * from "./bom_init.vue?vue&type=script&lang=js&"
import style0 from "./bom_init.vue?vue&type=style&index=0&id=46f223ed&scoped=true&lang=less&"
import style1 from "./bom_init.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f223ed",
  null
  
)

export default component.exports